import Vue from "vue";
import Router from "vue-router";
import { MessageBox } from "element-ui";
import utils from "../public/oidcRoot";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/notFound"
    },
    {
      path: "/",
      redirect: "/login" //登录
    },
    {
      path: "/login",
      name: "login", //登录
      component: resolve => require(["@/components/login/login"], resolve)
    },
    {
      path: "/vat",
      name: "navigation", //首页
      component: resolve =>
        require(["@/components/basics/navigation"], resolve),
      redirect: "/usUserInfo",
      children: [
        //二级头部菜单导航
        {
          path: "/usUserInfo", //用户中心
          name: "usUserInfo",
          component: resolve =>
            require(["@/components/vesaasModel/usUserInfo"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_UserCenterMenuItem",
            perantMenuItemName: "PlatformCenter",
            moduleHoverIndex: "UserCenterMenuItem",
            hoverIndex: "UserCenterMenuItem"
          }
        },
        {
          path: "/userManager", // 客户管理
          name: "userManager",
          component: resolve =>
            require(["@/components/vesaasModel/userManager"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_TenantListMenuItem",
            perantMenuItemName: "PlatformCenter",
            moduleHoverIndex: "TenantManagementMenuItem",
            hoverIndex: "TenantManagementMenuItem"
          }
        },
        {
          path: "/vatManager", // vat客户管理
          name: "vatManager",
          component: resolve =>
            require(["@/components/vesaasModel/vatManager"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ImportedTenantListMenuItem",
            perantMenuItemName: "PlatformCenter",
            moduleHoverIndex: "TenantManagementMenuItem",
            hoverIndex: "ImportedTenantListMenuItem"
          }
        },
        {
          path: "/vatHome",
          name: "vatHome", //vat首页
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatHomeAdminMenuItem",
            hoverIndex: "VatHomeAdminMenuItem"
          }
        },
        {
          path: "/vatUserList",
          name: "vatUserList", //vat首页
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatHomeAdminMenuItem",
            hoverIndex: "VatUserListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmUserList",
          name: "vatCrmUserList", //crm客户
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmUserListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmChannelList",
          name: "vatCrmChannelList", //crm渠道
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmChannelListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmServiceList",
          name: "vatCrmServiceList", //crm服务
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmServiceListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmProjectList",
          name: "vatCrmProjectList", //crm产品
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmProjectListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmAgentList",
          name: "vatCrmAgentList", //crm项目
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmAgentListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmProductOrderList",
          name: "vatCrmProductOrderList", //crm项目订单列表
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmProductOrderListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmNewUserList",
          name: "vatCrmNewUserList", //crm客户
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmNewUserListAdminMenuItem"
          }
        },
        {
          path: "/vatCrmNewServiceList",
          name: "vatCrmNewServiceList", //crm服务
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCrmUserListAdminMenuItem",
            hoverIndex: "VatCrmNewServiceListAdminMenuItem"
          }
        },

        {
          path: "/vatApply",
          name: "vatApply", //vat申请
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceDeclareMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatOrderMenuItem",
            hoverIndex: "VatDeclarationMenuItem"
          }
        },
        {
          path: "/vatLetter",
          name: "vatLetter", //vat信件管理
          // redirect:'/VAT',
          component: resolve =>
            require(["@/components/vat//vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceLetterMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatOrderMenuItem",
            hoverIndex: "VatLetterMenuItem"
          }
        },
        {
          path: "/vatRegisterOrder",
          name: "vatRegisterOrder", //vat 注册/转税代订单
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceTaxOrderMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatOrderMenuItem",
            hoverIndex: "VatOrderMenuItem"
          }
        },
        {
          path: "/vatIOSSOrder",
          name: "vatIOSSOrder", //ioss订单
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceIOSSMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatIOSSOrderMenuItem",
            hoverIndex: "VatIOSSOrderMenuItem"
          }
        },
        {
          path: "/vatIOSSDeclaredOrder",
          name: "vatIOSSDeclaredOrder", //ioss申报
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceDeclareMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatIOSSOrderMenuItem",
            hoverIndex: "VatIOSSDeclaredOrderMenuItem"
          }
        },
        {
          path: "/vatIOSSOffline",
          name: "vatIOSSOffline", //ioss线下数据管理
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatOfflineDataMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatIOSSOrderMenuItem",
            hoverIndex: "VatIOSSOfflineMenuItem"
          }
        },
        {
          path: "/VatNo",
          name: "VatNo", //vat 税号管理
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceTaxNumberMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatNoMenuItem",
            hoverIndex: "VatNoMenuItem"
          }
        },
        {
          path: "/VatCountry",
          name: "VatCountry", //vat 国家业务管理
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceCountryBusMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCountryMenuItem",
            hoverIndex: "VatCountryMenuItem"
          }
        },
        {
          path: "/VatTax",
          name: "VatTax", //vat 税代管理
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceTaxGenerationMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatCountryMenuItem",
            hoverIndex: "VatTaxMenuItem"
          }
        },
        {
          path: "/vatOtherBusiness",
          name: "vatOtherBusiness", //vat 其他业务
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceOtherOrderMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatOrderMenuItem",
            hoverIndex: "MyVatOtherFunctionsAdminMenuItem"
          }
        },
        {
          path: "/vatOfflineData",
          name: "vatOfflineData", //vat线下资料
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatOfflineDataMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatOrderMenuItem",
            hoverIndex: "VatOfflineDataMenuItem"
          }
        },
        {
          path: "/vatHistory",
          name: "vatHistory", //vat操作记录
          // redirect:'/VAT',
          component: resolve => require(["@/components/vat/vatIndex"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_VatServiceOpLogMenuItem",
            perantMenuItemName: "BusinessManagement",
            moduleHoverIndex: "VatNoMenuItem",
            hoverIndex: "VatHistoryMenuItem"
          }
        },
        //epr 德国 法国
        //合规服务 欧代/英代
        {
          path: "/eprList",
          name: "eprList",
          component: resolve => require(["@/components/epr/eprList"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "EPRAdminMenuItem"
          }
        },
        {
          path: "/eprList/detail",
          name: "eprDetail",
          component: resolve => require(["@/components/epr/detail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "EPRAdminMenuItem"
          }
        },
        {
          path: "/eprList/abnormal",
          name: "eprAbnormal",
          component: resolve => require(["@/components/epr/abnormal"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "EPRAdminMenuItem"
          }
        },
        {
          path: "/eneurList",
          name: "enEurList",
          component: resolve =>
            require(["@/components/compliance/eneur"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "ComplianceAdminMenuItem"
          }
        },
        {
          path: "/eneurList/detail",
          name: "enEurDetail",
          component: resolve =>
            require(["@/components/compliance/detail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "ComplianceAdminMenuItem"
          }
        },
        {
          path: "/eneurList/abnormal",
          name: "enEurAbnormal",
          component: resolve =>
            require(["@/components/compliance/abnormal"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "ComplianceAdminMenuItem"
          }
        },
        {
          path: "/eneurList/newProduct",
          name: "enEunewProduct",
          component: resolve =>
            require(["@/components/compliance/newProduct"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "ComplianceAdminMenuItem"
          }
        },
        {
          path: "/eneurList/newAbnormal",
          name: "enEunewAbnormal",
          component: resolve =>
            require(["@/components/compliance/newAbnormal"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "ComplianceServices",
            moduleHoverIndex: "ComplianceAdminMenuItem",
            hoverIndex: "ComplianceAdminMenuItem"
          }
        },
        {
          path: "/insuranceUnUserList",
          name: "UnUserList", //保险服务
          // redirect:'/VAT',
          component: resolve =>
            require(["@/components/insurance/UnUserList"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_PotentialTenantInsuranceServiceMenuItem",
            perantMenuItemName: "InsuranceManagement",
            moduleHoverIndex: "InsuranceUnUserListAdminMenuItem",
            hoverIndex: "InsuranceUnUserListAdminMenuItem"
          }
        },
        {
          path: "/regTrademark",
          name: "regTrademark", //商标注册
          // redirect:'/VAT',
          component: resolve =>
            require(["@/components/trademark/regTrademark"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_TradeMarkRegisterAdminMenuItem",
            perantMenuItemName: "TrademarkManagement",
            moduleHoverIndex: "TradeMarkRegisterAdminMenuItem",
            hoverIndex: "TradeMarkRegisterAdminMenuItem"
          }
        },
        {
          path: "/trademarkRetrieval",
          name: "trademarkRetrieval", //商标检索
          // redirect:'/VAT',
          component: resolve =>
            require(["@/components/trademark/trademarkRetrieval"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_TradeMarkRetrievalAdminMenuItem",
            perantMenuItemName: "TrademarkManagement",
            moduleHoverIndex: "TradeMarkRegisterAdminMenuItem",
            hoverIndex: "TradeMarkRetrievalAdminMenuItem"
          }
        },
        {
          path: "/tradPcSoftware",
          name: "tradPcSoftware", //计算机软件
          // redirect:'/VAT',
          component: resolve =>
            require(["@/components/trademark/tradPcSoftware"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_SoftwareCopyrightAdminMenuItem",
            perantMenuItemName: "TrademarkManagement",
            moduleHoverIndex: "TradeMarkRegisterAdminMenuItem",
            hoverIndex: "SoftwareCopyrightAdminMenuItem"
          }
        },
        {
          path: "/tradArt",
          name: "tradArt", //美术版权
          // redirect:'/VAT',
          component: resolve =>
            require(["@/components/trademark/tradArt"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ArtWorksCopyrightAdminMenuItem",
            perantMenuItemName: "TrademarkManagement",
            moduleHoverIndex: "TradeMarkRegisterAdminMenuItem",
            hoverIndex: "ArtWorksCopyrightAdminMenuItem"
          }
        },
        {
          path: "/vsNews",
          name: "vsNews", //所有的消息列表
          // redirect:'/vsNews',
          component: resolve =>
            require(["@/components/vesaas/vsNews"], resolve),
          meta: { isLogin: true }
        },
        {
          path: "/notFound",
          name: "notFound", //404
          component: resolve =>
            require(["@/components/basics/not-found"], resolve)
        },
        // {
        //   path: '/richText',
        //   name: 'richText',       //富文本
        //   component: resolve => require(['@/components/richText/richText'],resolve),
        // },
        {
          path: "/newsList",
          name: "newsList", //新闻列表
          component: resolve =>
            require(["@/components/document/newsList"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_NewsListMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "NewsManagementMenuItem",
            hoverIndex: "NewsManagementMenuItem"
          }
        },
        {
          path: "/addNews",
          name: "addNews", //新增新闻
          component: resolve =>
            require(["@/components/document/newsList/addNews"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_UpsertNews",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "NewsManagementMenuItem",
            hoverIndex: "UpsertNewsOperator"
          }
        },
        {
          path: "/newsDetail",
          name: "newsDetail", //新闻详情
          component: resolve =>
            require(["@/components/document/newsList/newsDetail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_NewsListMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "NewsManagementMenuItem",
            hoverIndex: "NewsListMenuItem"
          }
        },
        {
          path: "/categories",
          name: "categories", //新闻分类
          component: resolve =>
            require(["@/components/document/newsList/categories"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_NewsCategoryMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "NewsManagementMenuItem",
            hoverIndex: "NewsCategoryMenuItem"
          }
        },
        // {
        //   path: '/tagsManager',
        //   name: 'tagsManager',       //搜索标签管理
        //   component: resolve => require(['@/components/document/newsList/tags-manager'],resolve),
        //   meta:{
        //     isLogin:true,
        //     permissions:'Allow_NewsListMenuItem',
        //     perantMenuItemName:"ContentsManagementMenuItem",
        //     moduleHoverIndex:"NewsManagementMenuItem",
        //     hoverIndex:"NewsListMenuItem"
        //   }
        // },
        {
          path: "/docList",
          name: "docList", //文档列表
          component: resolve =>
            require(["@/components/document/docList"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualListMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "ManualManagementMenuItem",
            hoverIndex: "ManualManagementMenuItem"
          }
        },
        {
          path: "/addDoc",
          name: "addNews", //新增文档
          component: resolve =>
            require(["@/components/document/docList/addNews"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_UpsertManual",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "ManualManagementMenuItem",
            hoverIndex: "UpsertManualOperator"
          }
        },
        {
          path: "/docDetail",
          name: "docDetail", //文档详情
          component: resolve =>
            require(["@/components/document/docList/docDetail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualListMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "ManualManagementMenuItem",
            hoverIndex: "ManualManagementMenuItem"
          }
        },
        {
          path: "/docCategories",
          name: "docCategories", //文档分类
          component: resolve =>
            require(["@/components/document/docList/categories"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualCategoryMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "ManualManagementMenuItem",
            hoverIndex: "ManualCategoryMenuItem"
          }
        },
        // {
        //   path: '/docTagsManager',
        //   name: 'docTagsManager',       //文档搜索标签管理
        //   component: resolve => require(['@/components/document/docList/tags-manager'],resolve),
        //   meta:{
        //     isLogin:true,
        //     permissions:'Allow_NewsListMenuItem',
        //     perantMenuItemName:"ContentsManagementMenuItem",
        //     moduleHoverIndex:"NewsManagementMenuItem",
        //     hoverIndex:"NewsListMenuItem"
        //   }
        // },
        {
          path: "/manualNotification",
          name: "manualNotification", //人工通知
          component: resolve =>
            require(["@/components/document/manualNotification"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualNotificationMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "NotiManagementMenuItem",
            hoverIndex: "NotiManagementMenuItem"
          }
        },
        {
          path: "/addNotification",
          name: "addNotification", // 添加人工通知
          component: resolve =>
            require(["@/components/document/message/addNotification"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualNotificationMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "NotiManagementMenuItem",
            hoverIndex: "NotiManagementMenuItem"
          }
        },
        {
          path: "/banner",
          name: "banner", //广告banner
          component: resolve =>
            require(["@/components/document/bannerList"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualNotiManagementMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "BannerMenuItem",
            hoverIndex: "BannerMenuItem"
          }
        },
        {
          path: "/bannerHandel",
          name: "bannerHandel", //广告banner
          component: resolve =>
            require(["@/components/document/addBanner"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualNotiManagementMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "BannerMenuItem",
            hoverIndex: "BannerMenuItem"
          }
        },
        {
          path: "/manualNotification",
          name: "manualNotification", //人工通知
          component: resolve =>
            require(["@/components/document/manualNotification"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualNotificationMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "ManualManagementMenuItem",
            hoverIndex: "ManualManagementMenuItem"
          }
        },
        {
          path: "/systemMessage",
          name: "systemMessage", //系统消息
          component: resolve =>
            require(["@/components/document/systemMessage"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_SystemMessageMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "ManualManagementMenuItem",
            hoverIndex: "ManualCategoryMenuItem"
          }
        },
        {
          path: "/notificationDetail",
          name: "notificationDetail", //通知详情
          component: resolve =>
            require([
              "@/components/document/message/notificationDetail"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_ManualNotificationMenuItem",
            perantMenuItemName: "ContentsManagementMenuItem",
            moduleHoverIndex: "NotiManagementMenuItem",
            hoverIndex: "NotiManagementMenuItem"
          }
        },
        // {
        //   path: '/docTagsManager',
        //   name: 'docTagsManager',       //文档搜索标签管理
        //   component: resolve => require(['@/components/document/docList/tags-manager'],resolve),
        //   meta:{
        //     isLogin:true,
        //     permissions:'Allow_NewsListMenuItem',
        //     perantMenuItemName:"ContentsManagementMenuItem",
        //     moduleHoverIndex:"NewsManagementMenuItem",
        //     hoverIndex:"NewsListMenuItem"
        //   }
        // },
        {
          path: "/businessInfo",
          name: "businessInfo", //开发者中心- 企业信息
          component: resolve =>
            require(["@/components/developer/businessInfo"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevEnterpriseAdminMenuItem",
            perantMenuItemName: "developerCenter",
            moduleHoverIndex: "businessMenuItem",
            hoverIndex: "businessMenuItem"
          }
        },
        {
          path: "/businessInfo/:id",
          name: "businessInfoDetail", //开发者中心- 企业信息详情
          component: resolve =>
            require(["@/components/developer/businessInfoDetail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevEnterpriseAdminMenuItem",
            perantMenuItemName: "developerCenter",
            moduleHoverIndex: "businessMenuItem",
            hoverIndex: "businessMenuItem"
          }
        },
        {
          path: "/appList",
          name: "appList", //开发者中心- 应用列表
          component: resolve =>
            require(["@/components/developer/appList"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevAppAdminMenuItem",
            perantMenuItemName: "developerCenter",
            moduleHoverIndex: "businessMenuItem",
            hoverIndex: "appListMenuItem"
          }
        },
        {
          path: "/appList/:id",
          name: "appListDetail", //开发者中心- 应用列表详情
          component: resolve =>
            require(["@/components/developer/appListDetail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevAppAdminMenuItem",
            perantMenuItemName: "developerCenter",
            moduleHoverIndex: "businessMenuItem",
            hoverIndex: "appListMenuItem"
          }
        },
        {
          path: "/developerList",
          name: "developerList", //开发者中心- 开发者列表
          component: resolve =>
            require(["@/components/developer/developerList"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "developerCenter",
            moduleHoverIndex: "businessMenuItem",
            hoverIndex: "developerListMenuItem"
          }
        },
        {
          path: "/editDeveloperDoc",
          name: "editDeveloperDoc", //开发者中心- 发布文档
          component: resolve =>
            require(["@/components/developer/editDeveloperDoc"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "developerCenter",
            moduleHoverIndex: "businessMenuItem",
            hoverIndex: "editDeveloperDocMenuItem"
          }
        },
        {
          path: "/editMarkdown",
          name: "editMarkdown", //新建Markdown文档
          component: resolve =>
            require([
              "@/components/developer/editDeveloperDoc/editMarkdown"
            ], resolve)
        },
        {
          path: "/editApi",
          name: "editApi", //新建Api文档
          component: resolve =>
            require([
              "@/components/developer/editDeveloperDoc/editApi"
            ], resolve)
        },
        {
          path: "/developerDocType",
          name: "developerDocType", //开发者中心- 文档分类
          component: resolve =>
            require(["@/components/developer/developerDocType"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "developerCenter",
            moduleHoverIndex: "businessMenuItem",
            hoverIndex: "developerDocTypeMenuItem"
          }
        },
        {
          path: "/storeCenterAuthorization",
          name: "storeCenterAuthorization", //数据统计- 店铺中心授权
          component: resolve =>
            require([
              "@/components/dataStatistics/storeCenterAuthorization"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "userStatistics",
            hoverIndex: "storeCenterAuthorization"
          }
        },
        {
          path: "/userStatistics",
          name: "userStatistics", //数据统计- 用户统计
          component: resolve =>
            require(["@/components/dataStatistics/userStatistics"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "userStatistics",
            hoverIndex: "userStatistics"
          }
        },
        {
          path: "/userVATBusinessStatistics",
          name: "userVATBusinessStatistics", //数据统计- 用户VAT业务统计
          component: resolve =>
            require([
              "@/components/dataStatistics/userVATBusinessStatistics"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "userStatistics",
            hoverIndex: "userVATBusinessStatistics"
          }
        },
        {
          path: "/userTrademarkBusinessStatistics",
          name: "userTrademarkBusinessStatistics", //数据统计- 用户商标业务统计
          component: resolve =>
            require([
              "@/components/dataStatistics/userTrademarkBusinessStatistics"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "userStatistics",
            hoverIndex: "userTrademarkBusinessStatistics"
          }
        },
        {
          path: "/userTrackingServiceStatistics",
          name: "userTrackingServiceStatistics", //数据统计- 用户轨迹服务统计
          component: resolve =>
            require([
              "@/components/dataStatistics/userTrackingServiceStatistics"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "userStatistics",
            hoverIndex: "userTrackingServiceStatistics"
          }
        },
        {
          path: "/trajectoryDataAnalysis",
          name: "trajectoryDataAnalysis", //数据统计- 轨迹数据分析
          component: resolve =>
            require([
              "@/components/dataStatistics/trajectoryDataAnalysis"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "trajectoryDataAnalysis",
            hoverIndex: "trajectoryDataAnalysis"
          }
        },
        {
          path: "/userERPServiceStatistics",
          name: "userERPServiceStatistics", //数据统计- 用户ERP服务统计
          component: resolve =>
            require([
              "@/components/dataStatistics/userERPServiceStatistics"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "userStatistics",
            hoverIndex: "userERPServiceStatistics"
          }
        },
        {
          path: "/customerSpendingBehavior",
          name: "customerSpendingBehavior", //数据统计- 客户消费行为
          component: resolve =>
            require([
              "@/components/dataStatistics/customerSpendingBehavior"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "customerSpendingBehavior",
            hoverIndex: "customerSpendingBehavior"
          }
        },
        {
          path: "/trajectoryService",
          name: "trajectoryService", //数据统计-轨迹服务
          component: resolve =>
            require(["@/components/dataStatistics/trajectoryService"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "dataStatistics",
            moduleHoverIndex: "trajectoryService",
            hoverIndex: "trajectoryService"
          }
        },

        {
          path: "/refundlist",
          name: "refundlist", // 账务管理-支出
          component: resolve =>
            require([
              "@/components/productService/financialManagement/expence"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "purchaselist",
            hoverIndex: "refundlist"
          }
        },
        {
          path: "/refundlist",
          name: "refundlist", // 账务管理-支出
          component: resolve =>
            require([
              "@/components/productService/financialManagement/expence"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "purchaselist",
            hoverIndex: "refundlist"
          }
        },
        {
          path: "/purchaselist",
          name: "purchaselist", // 账务管理-收款
          component: resolve =>
            require([
              "@/components/productService/financialManagement/payment"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "purchaselist",
            hoverIndex: "purchaselist"
          }
        },
        {
          path: "/appRover",
          name: "appRover", // 账务管理-审批人配置
          component: resolve =>
            require([
              "@/components/productService/financialManagement/appRover"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "purchaselist",
            hoverIndex: "appRover"
          }
        },
        {
          path: "/approvalManagement",
          name: "approvalManagement", // 账务管理-支出
          component: resolve =>
            require([
              "@/components/productService/financialManagement/approvalManagement"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "purchaselist",
            hoverIndex: "approvalManagement"
          }
        },
        {
          path: "/refundDetails",
          name: "refundDetails", //产品服务-退费管理
          component: resolve =>
            require(["@/components/productService/refundDetails"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "purchaselist",
            hoverIndex: "refundlist"
          }
        },
        {
          path: "/packageManagement",
          name: "packageManagement", //产品服务-套餐管理
          component: resolve =>
            require(["@/components/productService/packageManagement"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "packageManagement",
            hoverIndex: "packageManagement"
          }
        },
        {
          path: "/productManagement",
          name: "productManagement", //产品服务-产品管理
          component: resolve =>
            require(["@/components/productService/productManagement"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "packageManagement",
            hoverIndex: "productManagement"
          }
        },
        {
          path: "/vatProductBuy",
          name: "vatProductBuy", //税号产品服务购买-购买管理
          component: resolve =>
            require(["@/components/productService/vatBuy/vatbuy"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductBuy",
            hoverIndex: "vatProductBuy"
          }
        },
        {
          path: "/vatProductBuy/detail",
          name: "buyDetail", //税号产品服务购买-购买管理
          component: resolve =>
            require(["@/components/productService/vatBuy/buyDetail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductBuy",
            hoverIndex: "vatProductBuy"
          }
        },
        {
          path: "/productBack",
          name: "productBack", //税号产品服务购买-退款管理
          component: resolve =>
            require([
              "@/components/productService/backManage/backList"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductBuy",
            hoverIndex: "productBack"
          }
        },
        {
          path: "/invoiceManage",
          name: "invoiceManage", //税号产品服务购买-退款管理
          component: resolve =>
            require(["@/components/productService/invoice/invoice"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductBuy",
            hoverIndex: "invoiceManage"
          }
        },
        // invoiceManage
        {
          path: "/productBack/detail",
          name: "backDetail", //税号产品服务购买-退款管理
          component: resolve =>
            require([
              "@/components/productService/backManage/backDetail"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductBuy",
            hoverIndex: "productBack"
          }
        },
        {
          path: "/renewTip",
          name: "renewTip", //续费管理
          component: resolve =>
            require(["@/components/productService/renewTip/renewTip"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "renewTip",
            hoverIndex: "renewTip"
          }
        },
        {
          path: "/sysRevise",
          name: "sysRevise", //续费管理
          component: resolve =>
            require(["@/components/productService/sysRevise/revise"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "sysRevise",
            hoverIndex: "sysRevise"
          }
        },
        {
          path: "/vatProductManagement",
          name: "vatProductManagement", //税号产品服务-产品管理
          component: resolve =>
            require(["@/components/productService/vatProduct"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductManagement",
            hoverIndex: "vatProductManagement"
          }
        },
        {
          path: "/vatProductManagement/addProduct",
          name: "addProduct", //税号产品服务-添加、编辑产品
          component: resolve =>
            require(["@/components/productService/addProduct"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductManagement",
            hoverIndex: "vatProductManagement"
          }
        },
        {
          path: "/vatProductManagement/vatProductDetail",
          name: "vatProductDetail", //税号产品服务-添加、编辑产品
          component: resolve =>
            require(["@/components/productService/vatProductDetail"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "vatProductManagement",
            hoverIndex: "vatProductManagement"
          }
        },
        {
          path: "/addNewPackage",
          name: "addNewPackage", //产品服务-新建套餐
          component: resolve =>
            require(["@/components/productService/addNewPackage"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "packageManagement",
            hoverIndex: "packageManagement"
          }
        },
        {
          path: "/packageDetails",
          name: "packageDetails", //产品服务-套餐详情
          component: resolve =>
            require(["@/components/productService/packageDetails"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "productService",
            moduleHoverIndex: "packageManagement",
            hoverIndex: "packageManagement"
          }
        },

        {
          path: "/addNewProduct",
          name: "addNewProduct", //产品服务-新建套餐
          component: resolve =>
            require(["@/components/productService/addNewProduct"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            erantMenuItemName: "productService",
            moduleHoverIndex: "packageManagement",
            hoverIndex: "productManagement"
          }
        },
        {
          path: "/productDetails",
          name: "productDetails", //产品服务-产品详情
          component: resolve =>
            require(["@/components/productService/productDetails"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            erantMenuItemName: "productService",
            moduleHoverIndex: "packageManagement",
            hoverIndex: "productManagement"
          }
        },
        {
          path: "/trackingAnalysis",
          name: "trackingAnalysis", //轨迹追踪-物流轨迹分析配置
          component: resolve =>
            require(["@/components/trackingtrace/trackingAnalysis"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "trackingTrace",
            moduleHoverIndex: "trackingAnalysis",
            hoverIndex: "trackingAnalysis"
          }
        },
        {
          path: "/addediteTrackingAnalysis",
          name: "addediteTrackingAnalysis", //轨迹追踪-添加和编辑物流轨迹分析配置
          component: resolve =>
            require([
              "@/components/trackingtrace/addediteTrackingAnalysis"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "trackingTrace",
            moduleHoverIndex: "trackingAnalysis",
            hoverIndex: "trackingChase"
          }
        },
        {
          path: "/trackingAnalysisDetails",
          name: "trackingAnalysisDetails", //轨迹追踪-物流轨迹分析配置详情
          component: resolve =>
            require([
              "@/components/trackingtrace/trackingAnalysisDetails"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "trackingTrace",
            moduleHoverIndex: "trackingAnalysis",
            hoverIndex: "trackingAnalysis"
          }
        },
        {
          path: "/trackingChase",
          name: "trackingChase", //轨迹追踪-物流轨迹分析配置详情
          component: resolve =>
            require(["@/components/trackingtrace/trackingChase"], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "trackingTrace",
            moduleHoverIndex: "trackingAnalysis",
            hoverIndex: "trackingChase"
          }
        },
        {
          path: "/trackingYeeWaybillQueryList",
          name: "trackingYeeWaybillQueryList", //轨迹追踪-运单查询列表
          component: resolve =>
            require([
              "@/components/trackingtrace/trackingYeeWaybillQueryList"
            ], resolve),
          meta: {
            isLogin: true,
            permissions: "Allow_DevUserAdminMenuItem",
            perantMenuItemName: "trackingTrace",
            moduleHoverIndex: "trackingYeeQueryWaybill",
            hoverIndex: "trackingYeeQueryWaybill"
          }
        }
        // {
        //   path: '/channelManagement',
        //   name: 'channelManagement',       //渠道管理
        //   // redirect:'/VAT',
        //   component: resolve => require(['@/components/affiliate/affiliateIndex'], resolve),
        //   meta: {
        //     isLogin: true,
        //     permissions: '',
        //     perantMenuItemName:"distributionSystem",
        //     moduleHoverIndex:"channelManagement",
        //     hoverIndex:"channelManagement"
        //   }
        // },{
        //   path: '/userManagement',
        //   name: 'userManagement',       //用户管理
        //   // redirect:'/VAT',
        //   component: resolve => require(['@/components/affiliate/affiliateIndex'], resolve),
        //   meta: {
        //     isLogin: true,
        //     permissions: '',
        //     perantMenuItemName:"distributionSystem",
        //     moduleHoverIndex:"userManagement",
        //     hoverIndex:"userManagement"
        //   }
        // },{
        //   path: '/fundDetails',
        //   name: 'fundDetails',       //资金明细
        //   // redirect:'/VAT',
        //   component: resolve => require(['@/components/affiliate/affiliateIndex'], resolve),
        //   meta: {
        //     isLogin: true,
        //     permissions: '',
        //     perantMenuItemName:"distributionSystem",
        //     moduleHoverIndex:"fundDetails",
        //     hoverIndex:"fundDetails"
        //   }
        // },{
        //   path: '/orderDetails',
        //   name: 'orderDetails',       //订单明细
        //   // redirect:'/VAT',
        //   component: resolve => require(['@/components/affiliate/affiliateIndex'], resolve),
        //   meta: {
        //     isLogin: true,
        //     permissions: '',
        //     perantMenuItemName:"distributionSystem",
        //     moduleHoverIndex:"orderDetails",
        //     hoverIndex:"orderDetails"
        //   }
        // },
      ]
    },
    {
      path: "/callback",
      name: "callback", //回调地址
      component: resolve => require(["@/components/basics/callback"], resolve)
    },
    {
      path: "/main",
      name: "main", //一级左侧vesaas
      // redirect:'/home',
      component: resolve => require(["@/components/basics/main"], resolve),
      children: [
        {
          path: "/forgetPsd",
          name: "forgetPsd", //忘记密码
          component: resolve =>
            require(["@/components/basics/forgetPsd"], resolve)
        },
        {
          path: "/againEmail",
          name: "againEmail", //再次验证邮箱
          component: resolve =>
            require(["@/components/basics/againEmail"], resolve)
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  // if(to.matched.meta)
  //
  // to.matched.map(item=>{
  //   if(item.meta.isLogin){
  //     utils.isLogin(item.meta.permissions,next);
  //   }else{
  next();
  //   }
  //   localStorage["perantMenuItemName"] = item.meta.perantMenuItemName;
  //   localStorage["moduleHoverIndex"] = item.meta.moduleHoverIndex;
  //   localStorage["hoverIndex"] = item.meta.hoverIndex;
  // })
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js